var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.5C11 21.0523 11.4477 21.5 12 21.5C12.5523 21.5 13 21.0523 13 20.5V6.41406L17.6572 11.0713C18.0478 11.4615 18.6809 11.4617 19.0713 11.0713C19.4617 10.6809 19.4615 10.0478 19.0713 9.65723L12.707 3.29297C12.3165 2.90244 11.6835 2.90244 11.293 3.29297L4.92871 9.65723C4.53848 10.0478 4.53828 10.6809 4.92871 11.0713C5.31914 11.4617 5.95222 11.4615 6.34277 11.0713L11 6.41406V20.5Z",
    fill: "#F5373A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRed);
export default __webpack_public_path__ + "static/media/arrow-up-red.e8f631c169670d73250104aff5d3e9ad.svg";
export { ForwardRef as ReactComponent };